import { Box, BoxProps, Collapse, CollapseProps } from '@mui/material';
import React from 'react';
import { Search, SearchProps } from './Search';

export interface CollapsableSearchProps extends BoxProps {
  /**
   * Defines whether the search should be collapsed or not
   */
  isCollapsed: boolean;
  /**
   * Properties of Search component
   *
   * @see Search
   */
  searchProps?: SearchProps;
  /**
   * Properties of Mui Collapse component
   *
   * @see Collapse https://mui.com/material-ui/api/collapse/
   */
  collapseProps?: CollapseProps;
}

export const CollapsableSearch: React.FC<CollapsableSearchProps> = ({
  isCollapsed,
  searchProps,
  collapseProps,
  ...boxProps
}) => {
  const { sx: boxSx, ...restBoxProps } = boxProps || {};
  const { sx: collapseSx, ...restCollapseProps } = collapseProps || {};

  return (
    <Box sx={{ width: 'fit-content', ...boxSx }} {...restBoxProps}>
      <Collapse
        in={!isCollapsed}
        orientation="horizontal"
        collapsedSize="44px"
        sx={{
          borderRadius: '200px',
          display: 'flex',
          justifyContent: 'flex-end',
          width: 'fit-content',
          '& input': {
            width: 'auto',
          },
          ...collapseSx,
        }}
        {...restCollapseProps}
      >
        <Search disableInput={isCollapsed} {...searchProps} />
      </Collapse>
    </Box>
  );
};
